module.exports = __webpack_public_path__ + "static/media/dk4020y.1c8a8efb.png";